module.exports = "/images/vendor/flag-icon-css/flags/4x3/ms.svg?e147bd2bb2aa7f31e3804673c8564340";